module.exports = __webpack_public_path__ + "img/ss_blue-02.197bc5ce.jpg";